import { Phone } from "lucide-react";
import { PHONE } from "@/content";

const STYLES = {
  light: "border border-slate-300 bg-white/70 text-brand-ink hover:border-brand-orange hover:text-brand-orange",
  dark: "border border-white/20 bg-white/10 text-white hover:bg-white hover:text-brand-ink",
  ink: "bg-brand-ink text-white hover:bg-brand-orange",
};

export const CallButton = ({ variant = "light", testid = "call-button", label = "Llamar ahora", iconOnly = false, className = "" }) => (
  <a
    href={PHONE.tel}
    data-testid={testid}
    aria-label={`Llamar al ${PHONE.intl}`}
    title={`Llamar al ${PHONE.intl}`}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-full font-bold transition-colors duration-300 ${STYLES[variant]} ${
      iconOnly ? "h-[54px] w-[54px]" : "px-7 py-4 text-[15px]"
    } ${className}`}
  >
    <Phone className="h-[18px] w-[18px] transition-transform duration-300 group-hover:rotate-12" />
    {!iconOnly && (
      <span>
        {label} <span className="font-mono2 text-xs opacity-70 ml-1">{PHONE.display}</span>
      </span>
    )}
  </a>
);
